import React from "react";
import TrackedSelectedOptions from "./TrackedSelectedOptions";
import usePermission from "../../../../hooks/usePermission";

export default function TrackedSelectedControls({ device, values }) {
	const { view: Engineview } = usePermission(
		"LIVETRACKINGCONTROLSCONTROLENGINE",
	);
	const { view: Alertsview, edit: Alertsedit } = usePermission(
		"LIVETRACKINGCONTROLSALERTS",
	);

	return (
		<>
			{Engineview && (
				<>
					<div>
						<TrackedSelectedOptions
							option1="start engine"
							option2="stop engine"
							device={values}
							disabled={false}
						/>
					</div>
					<div>
						<TrackedSelectedOptions
							option1="set speed limit"
							option2="set geofence"
							device={values}
							disabled={false}
						/>
					</div>
				</>
			)}

			<div>
				<TrackedSelectedOptions
					option1="open sessions"
					option2="share location"
					device={values}
					disabled={true}
				/>
			</div>
			{Alertsview && Alertsedit && (
				<>
					<div>
						<TrackedSelectedOptions
							option1="fuel drop threshold"
							option2="fuel increase threshold"
							device={values}
							disabled={false}
						/>
					</div>

					<div>
						<TrackedSelectedOptions
							option1="set notification"
							device={values}
							disabled={false}
						/>
					</div>
				</>
			)}
		</>
	);
}
